import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslocoRootModule } from "./transloco-root.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouteReuseStrategy } from "@angular/router";
import { CustomReuseStrategy } from "./reuse";
import { SelectComponent } from "../components/select/select.component";
import { InputComponent } from "../components/input/input.component";
import { MiniCalendarComponent } from "../components/mini-calendar-component";
import { ThankComponent } from "./thank/thank.component";
import { ToggleComponent } from "../components/toggle/toggle.component";
import { PayComponent } from "./pay/pay.component";
@NgModule({
  declarations: [
    AppComponent,
    SelectComponent,
    InputComponent,
    MiniCalendarComponent,
    ThankComponent,
    ToggleComponent,
    PayComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslocoRootModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()),{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
})
export class AppModule {}
